/**
 * Official WhatsApp glyph as an inline SVG so we can control size and color
 * from Tailwind classes. Path is the Wikimedia public-domain WhatsApp logo,
 * simplified to the phone-in-chat mark on a single fill.
 *
 * Sizes used across the app:
 *   • buttons          → className="w-5 h-5"   (20px)
 *   • floating action  → className="w-6 h-6"   (24px)
 *   • support section  → className="w-8 h-8"   (32px)
 *
 * Default color is the official brand green (#25D366) via `fill="currentColor"`
 * combined with `text-[#25D366]` on the caller, or via the `color` prop.
 */
export default function WhatsAppIcon({ className = "w-5 h-5", color = "#25D366", ...rest }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      <path
        fill={color}
        d="M16 3C8.82 3 3 8.82 3 16c0 2.29.6 4.52 1.74 6.48L3 29l6.7-1.75A12.94 12.94 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3zm0 23.6c-2.02 0-3.98-.54-5.7-1.55l-.41-.24-3.98 1.04 1.06-3.88-.26-.4A10.55 10.55 0 0 1 5.4 16c0-5.85 4.75-10.6 10.6-10.6S26.6 10.15 26.6 16 21.85 26.6 16 26.6zm5.83-7.94c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.72.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.68.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.5.14-.66.14-.14.32-.37.48-.55.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.55-.08-.16-.72-1.74-.99-2.38-.26-.62-.53-.54-.72-.55l-.61-.01c-.21 0-.55.08-.84.4-.29.32-1.1 1.07-1.1 2.61s1.13 3.03 1.29 3.24c.16.21 2.22 3.4 5.38 4.77.75.32 1.34.51 1.8.66.75.24 1.44.21 1.98.13.6-.09 1.88-.77 2.14-1.51.26-.74.26-1.37.19-1.51-.08-.13-.29-.21-.61-.37z"
      />
    </svg>
  );
}
